import { LOGIN_SUCCESS, LOGOUT, EXPIRED } from '../Action-type/authActionType';


export const loginUserApi = (data) => async (dispatch) => {
  dispatch({ type: LOGIN_SUCCESS, payload: data });
}

export const logoutApi = () => async (dispatch) => {
  dispatch({ type: LOGOUT });
}
export const sessionExpired = () => async (dispatch) => {
  dispatch({ type: EXPIRED });
}


